import React from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type ReadMoreType = {
  isLoading?: boolean;
  onClick?: () => void;
};
export default function ReadMore({ isLoading, onClick }: ReadMoreType) {
  const { t } = useTranslation();

  return (
    <Box justifyContent="center" display="flex">
      <Button
        variant="outlined"
        color="secondary"
        sx={{
          textTransform: "initial",
          fontWeight: 700,
          width: 180,
          height: 55,
          border: 1,
        }}
        onClick={onClick}
      >
        {isLoading ? (
          <CircularProgress color="secondary" size={30} />
        ) : (
          <Typography variant="subtitle1" fontWeight={700}>
            {t("BUTTON_READ_MORE")}
          </Typography>
        )}
      </Button>
    </Box>
  );
}
